import React from 'react'

function Sales() {
  return (
    <div>Sales (linked to OPD/IPD prescriptions)</div>
  )
}

export default Sales